<template>
  <v-menu
    ref="menu"
    v-model="dateMenu"
    :close-on-content-click="false"
    :return-value.sync="expireAt"
    transition="scale-transition"
    offset-x
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="expireAt"
        :label="$t('videoconf.form.fields.expireAt')"
        prepend-icon="mdi-timer"
        :rules="dateRules"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="expireAt" no-title scrollable :min="minDate().toISOString()">
      <v-spacer></v-spacer>
      <v-btn text @click="dateMenu = false"> {{ $t('videoconf.form.cancel') }} </v-btn>
      <v-btn text color="primary" @click="pick()"> {{ $t('videoconf.form.pick') }} </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data () {
    return {
      expireAt: this.expires.toISOString().split('T')[0],
      dateMenu: null,
      rules: { required: v => !!v || this.$t('videoconf.form.required') },
      dateRules: [
        (v) => !!v || this.$t('videoconf.form.fields.validations.expireAt.required'),
        (v) => {
          const date = new Date(v)
          return date >= this.minDate() || this.$t('videoconf.form.fields.validations.expireAt.min', { date: this.minDate().toISOString().split('T')[0] })
        }
      ]
    }
  },
  props: {
    expires: {
      type: Date,
      default () {
        return new Date()
      }
    }
  },
  methods: {
    pick () {
      this.$refs.menu.save(this.expireAt)
      this.$emit('setModel', new Date(this.expireAt))
    },

    minDate () {
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow
    }
  }
}
</script>

<style>

</style>
